
<app-type-adresse-complete-morale *ngIf="isLotAttribue()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [titulaire]="attribue?.titulaire" [errorMessagePersonneMoral]="errorMessagePersonneMoral" [required]="'required'">
</app-type-adresse-complete-morale>
<app-type-adresse-complete-morale *ngIf="!isLotAttribue()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
    [titulaire]="attribue?.titulaire" [errorMessagePersonneMoral]="errorMessagePersonneMoral" [required]="'required'">
</app-type-adresse-complete-morale>
<fieldset>
    <legend>
        {{ step4.getspan9 | translate }}
    </legend>
    <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="''" [label]="step4.getmontantindefini"
        [type]="'checkbox'" [rule]="'pattern_29'" [name]="getUid() + '_SepAtt_montantIndefini'"
        [isChecked]="attribue?.montantIndefini" [checkboxDestination]="'string'">
    </app-form-input>
    <div *ngIf="isMontantDefini()">
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.montant?.valeur"
            [label]="step4.getvaleur" [type]="'number'" [rule]="'digits_2'" [name]="getUidTypeMontant() + '_SepAtt_valeur'">
        </app-form-input>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.montant?.devise"
            [label]="step4.getdevise"
            [type]="'autocomplete'"
            [autoCompleteType]="'DEVISE'"
            [autoCompleteTypeIndex]="0"
            [rule]="'pattern_13'"
            [errorMessage]="{}"
            [name]="getUidTypeMontant() + '_SepAtt_devise'">
        </app-form-input>
        <app-montant-annuel [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
            [montantAnnuel]="attribue?.montantAnnuel">
        </app-montant-annuel>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.trancheConditionnelle"
            [label]="step4.gettrancheconditionnelle" [type]="'text'" [rule]="'minSize_5|maxSize_2000'"
            [name]="getUid() + '_SepAtt_trancheConditionnelle'">
        </app-form-input>
        <app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="attribue?.trancheFerme"
            [label]="step4.gettrancheferme" [type]="'text'" [rule]="'minSize_5|maxSize_2000'" [name]="getUid() + '_SepAtt_trancheFerme'">
        </app-form-input>
        <app-offres [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled" [offres]="attribue?.offres">
        </app-offres>
        <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1 + index" [id]="getStepId() + rg1 + index"></app-form-input-error>
    </div>
</fieldset>
<fieldset>
    <legend>
        {{ step4.getspan10 | translate }}
    </legend>
    <app-form-input [label]="" [name]="radioButtonCtrlName" [parentForm]="parentForm" [disabled]="disabled"
        [type]="'radio'" [rule]="''" [radios]="[
    {
        value: true,
        label: step4.getspan11
    },
    {
        value: false,
        label: step4.getsoustraitancenon
    }
]" [value]="attribue?.isSousTraitance">
    </app-form-input>
    <app-sous-traitance-oui *ngIf="isSousTraitance()" [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
        [sousTraitanceOui]="attribue?.sousTraitanceOui" [index]="index"></app-sous-traitance-oui>
</fieldset>
